import {
  useBrokersServiceBrokersUsersDestroy,
  useBrokersServiceBrokersUsersListKey
} from '@insurance/api/queries'
import { getFullName, showApiErrors } from '@shared/utils'
import { useQueryClient } from '@tanstack/react-query'
import { App, Modal } from 'antd'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { CommonPropsAgent } from './types'

export const DeleteAgent = ({
  data,
  onSuccess,
  open,
  onCancel
}: CommonPropsAgent) => {
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal()
  const { message } = App.useApp()
  const queryClient = useQueryClient()

  const { mutateAsync: deleteMutation } = useBrokersServiceBrokersUsersDestroy({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [useBrokersServiceBrokersUsersListKey]
      })

      message.success(t('removed_successfully'))

      onSuccess()
    },
    onError: (error) => showApiErrors(error)
  })

  useEffect(() => {
    const id = data?.id
    if (!id) return

    const { destroy } = modal.confirm({
      title: t('delete_confirm'),
      content: (
        <span
          dangerouslySetInnerHTML={{
            __html: t('delete_confirm_description_agent', {
              name: getFullName(data)
            })
          }}
        />
      ),
      okText: t('delete'),
      okType: 'danger',
      onOk: () => deleteMutation({ id }),
      open,
      onCancel
    })

    return destroy
  }, [data, deleteMutation, modal, onCancel, open, t])

  return contextHolder
}
